import { createSimpleFunctional } from '@/util'

export default createSimpleFunctional('flex-grow-1', 'div', 'VSpacer')
